import React from "react";
import "./RightBar.css";

function RightBar() {
  return (
    <div className="right-sidebar">
      <a href="mailto:vikasmpawar07@gmail.com" className="vertical-email">
        vikasmpawar07@gmail.com
      </a>
      <div className="vertical-line"></div>
    </div>
  );
}

export default RightBar;
